<svc-dialog #dialog [hasActions]="false">
  <div svc-dialog-title>
    {{ title | transloco }}
  </div>

  <div svc-dialog-content class="m-4">
    <p class="text-sm px-2">
      {{ text | transloco }}
    </p>

    <div mat-dialog-actions class="flex justify-end p-2 mt-5">
      <div class="flex gap-2">
        <button
          svc-filled-btn
          id="svc-warning-dialog-button-confirm"
          type="button"
          (click)="closeDialog()"
        >
          {{ buttonText | transloco }}
        </button>
      </div>
    </div>
  </div>
</svc-dialog>
